package com.ives.modules.roi;

import com.ives.components.messagehandler.MessageHandler;
import haxe.Timer;
import js.html.TouchEvent;
import js.html.MouseEvent;

import com.ives.utils.math.Vector3D;
import com.ives.components.viewer.DicomViewer;
import com.ives.modules.crosssection.CardinalSpline;
import com.ives.components.workspace.DicomWorkspace;
import com.ives.utils.Log;

class ROI extends Module{
	static public inline var ROI_EVENT:String = "ROI_EVENT";
	static public inline var ROI_MESSAGE:String = "ROI_MESSAGE";
	static public inline var ROI_CURRENT:String = "ROI_CURRENT";
	static public inline var ROI_OTHER:String = "ROI_OTHER";

	private var points:Array<Float> = [];
	private var savePoints:Array<Float>;

	private var popup:ROIPopup;

	private var lastTouch:Vector3D;
	private var lastTap:Float = 0;

	override public function init(dicomViewer:DicomViewer, ?dicomWorkspace:DicomWorkspace){
		super.init(dicomViewer, dicomWorkspace);

		dicomWorkspace.on("mousemove", onMouseMove);
		dicomWorkspace.on("mouseup", onMouseUp);
		dicomWorkspace.on("dblclick", onDoubleClick);

		dicomWorkspace.on("touchmove", onTouchMove);
		dicomWorkspace.on("touchend", onTouchEnd);

		Log.debug('ROI init');

		popup = new ROIPopup(onClose);
	}

	override public function handleModuleEvent(event:ModuleEvent){
		if(event.type == ROI_MESSAGE){
			var description:String = event.strings[0];
			var action:String = event.strings[1];
			var id = event.points.toString();

			if(action == ROIData.HIDE){
				drawings.remove(id);

				redraw();
			}

			if(action == ROIData.SHOW){
				var curve:Array<Float> = CardinalSpline.getCurvePoints(pointsToFloats2D(volumeToLocal(floatsToPoints3D(event.points))), 0.5, 25, true);

				addDrawing(new Drawing(Drawing.SHAPE, pointsToFloats3D(localToVolume(floatsToPoints2D(curve))), event.points, id, true));
			}
		}

		if(event.type == ROI_EVENT){
			var curve:Array<Float> = CardinalSpline.getCurvePoints(pointsToFloats2D(volumeToLocal(floatsToPoints3D(event.points))), 0.5, 25, true);

			addDrawing( new Drawing(Drawing.SHAPE, pointsToFloats3D(localToVolume(floatsToPoints2D(curve))), event.points, ROI_CURRENT, !event.editable) );
		}

		if(event.type == DicomViewer.RESIZE)
			redraw();
	}

	private function onTouchMove(event:TouchEvent){
		if(!dicomViewer.roiButton.checked)
			return;

		lastTouch = touchToVolume(event);

		onMove(lastTouch);
	}

	private function onMouseMove(event:MouseEvent){
		if(hasModifier(event))
			return;

		if(!dicomViewer.roiButton.checked)
			return;

		onMove(mouseToVolume(event));
	}

	private function onMove(image:Vector3D){
		if(!dicomViewer.roiButton.checked)
			return;

		if(onDrawingMouseMove(image.x, image.y, image.z))
			return;

		if(points.length == 0)
			return;

		var temp:Array<Float> = points.copy();

		temp.push(image.x);
		temp.push(image.y);
		temp.push(image.z);

		dispatchEvent(new ModuleEvent(ROI_EVENT, temp, dicomWorkspace.id, false, false));
	}

	private function onMouseUp(event:MouseEvent){
		if(hasModifier(event))
			return;

		onUp(mouseToVolume(event));
	}

	private function onUp(image:Vector3D){
		if(!dicomViewer.roiButton.checked)
			return;

		if(onDrawingMouseUp(image.x, image.y, image.z))
			return;

		points.push(image.x);
		points.push(image.y);
		points.push(image.z);

		if(points.length > 3)
			dispatchEvent(new ModuleEvent(ROI_EVENT, points, dicomWorkspace.id, false, false));
	}

	private function onTouchEnd(event:TouchEvent){
		var now:Float = Timer.stamp();

		if(now - lastTap < 0.5){
			onDouble(true);

			lastTap = now;

			return;
		}

		lastTap = now;

		onUp(lastTouch);
	}

	private function onDoubleClick(){
		onDouble(false);
	}

	private function onDouble(touch:Bool){
		if(!dicomViewer.roiButton.checked)
			return;

		if(points.length > 6){
			if(!touch){
				points.pop();
				points.pop();
				points.pop();
			}

			dispatchEvent(new ModuleEvent(ROI_EVENT, points, dicomWorkspace.id, false, false));
		}

		savePoints = points;
		points = [];

		popup.open();
	}

	private function onClose(save:Bool, ?description:String){
		if(save){
			var roiData:ROIData = new ROIData(ROIData.NEW, dicomWorkspace.dicomImageData.id, description, savePoints);

			MessageHandler.send(roiData);
		}

		drawings.remove(ROI_CURRENT);

		redraw();
	}
}
